export const currentCustomer = state => state.currentCustomer;
export const customersList = state => state.customersList;
export const customersTotal = state => state.customersTotal;
